export default __webpack_public_path__ + "static/sports-f058345ce668bbb460f2d018c80ded8c.png";